import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Components
import HomePage from './pages/Home';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
